import React, { useState } from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button
} from '@mui/material'

interface Props {
    open: boolean
    onClose: (name: string | null) => void
}

const SectionNameDialog = ({ open, onClose }: Props) => {
    const [name, setName] = useState("")

    const handleAdd = () => {
        onClose(name.trim())
        setName("")
    }

    const handleCancel = () => {
        onClose(null)
        setName("")
    }

    return (
        <Dialog open={open} onClose={handleCancel}>
            <DialogTitle>Enter Section Name</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    fullWidth
                    label="Section Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>Cancel</Button>
                <Button onClick={handleAdd} disabled={!name.trim()}>Add</Button>
            </DialogActions>
        </Dialog>
    )
}

export default SectionNameDialog
